'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; /**
                                   * Created by lyj on 2016/10/25.
                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _reduxForm = require('redux-form');

var _SubmitBtn = require('../SubmitBtn/SubmitBtn');

var _SubmitBtn2 = _interopRequireDefault(_SubmitBtn);

var _GoeasyInputField = require('../GoeasyInputField/GoeasyInputField');

var _GoeasyInputField2 = _interopRequireDefault(_GoeasyInputField);

var _ErrorLabel = require('../ErrorLabel/ErrorLabel');

var _ErrorLabel2 = _interopRequireDefault(_ErrorLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompanyInfoModal = (_dec = (0, _reduxForm.reduxForm)({
  form: 'companyInfoModal',
  fields: ['companyName', 'contactName', 'contactMobile', 'addressDetail']
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(CompanyInfoModal, _Component);

  function CompanyInfoModal() {
    (0, _classCallCheck3.default)(this, CompanyInfoModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(CompanyInfoModal).call(this));

    _this.state = {
      closeHover: false
    };
    return _this;
  }

  (0, _createClass3.default)(CompanyInfoModal, [{
    key: 'closeImgMouseOver',
    value: function closeImgMouseOver() {
      this.setState({
        closeHover: true
      });
    }
  }, {
    key: 'closeImgMouseLeave',
    value: function closeImgMouseLeave() {
      this.setState({
        closeHover: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./CompanyInfoModal.scss');
      var _props = this.props;
      var _props$fields = _props.fields;
      var companyName = _props$fields.companyName;
      var contactName = _props$fields.contactName;
      var contactMobile = _props$fields.contactMobile;
      var addressDetail = _props$fields.addressDetail;
      var operating = _props.operating;
      var errMessage = _props.errMessage;
      var handleSubmit = _props.handleSubmit;
      var _props2 = this.props;
      var onClose = _props2.onClose;
      var isOpened = _props2.isOpened;

      var customStyle = {
        content: {
          background: '#fff',
          overflow: 'hidden',
          outline: 'none',
          zIndex: 10,
          border: '0',
          boxShadow: '3px 2px 20px',
          borderRadius: '30px',
          bottom: 'auto',
          minHeight: '10rem',
          left: '50%',
          padding: '2rem',
          position: 'fixed',
          right: 'auto',
          top: '50%',
          transform: 'translate(-50%,-50%)',
          minWidth: '20rem',
          width: '750px',
          maxWidth: '60rem'
        }
      };
      var closeHover = this.state.closeHover;

      var hoverClassName = styles.zhuan_a;
      if (closeHover) {
        hoverClassName = styles.zhuan;
      }
      return _react2.default.createElement(
        _reactModal2.default,
        { style: customStyle, isOpen: isOpened },
        _react2.default.createElement(
          'div',
          { className: styles.close },
          _react2.default.createElement('img', { className: hoverClassName, onMouseOver: this.closeImgMouseOver.bind(this),
            onMouseLeave: this.closeImgMouseLeave.bind(this), onClick: function onClick() {
              return onClose();
            },
            src: 'http://tupian.goeasy.cn:9999/yipinwang/third/close.png', alt: '',
            width: '100%' })
        ),
        _react2.default.createElement(
          'form',
          { className: styles.component, onSubmit: handleSubmit },
          _react2.default.createElement(_GoeasyInputField2.default, { label: '企业名称：', fieldStyle: { width: '300px' }, formProps: companyName }),
          _react2.default.createElement(_GoeasyInputField2.default, { label: '联系人：', fieldStyle: { width: '100px' }, formProps: contactName }),
          _react2.default.createElement(_GoeasyInputField2.default, { label: '联系方式：', fieldStyle: { width: '100px' }, formProps: contactMobile }),
          _react2.default.createElement(_GoeasyInputField2.default, { inputType: 'textarea', label: '地址：', formProps: addressDetail }),
          _react2.default.createElement('div', { className: 'clear' }),
          errMessage ? _react2.default.createElement(_ErrorLabel2.default, { error: errMessage }) : '',
          _react2.default.createElement('div', { className: 'clear' }),
          _react2.default.createElement(_SubmitBtn2.default, { style: { display: operating ? 'none' : 'block', marginRight: '90px', marginTop: '21px' },
            btnClick: handleSubmit,
            text: '提交' }),
          _react2.default.createElement(_SubmitBtn2.default, { style: { display: operating ? 'none' : 'block', marginRight: '130px', marginTop: '21px' },
            btnClick: onClose,
            text: '关闭' })
        )
      );
    }
  }]);
  return CompanyInfoModal;
}(_react.Component), _class2.propTypes = {
  active: _react.PropTypes.string,
  asyncValidating: _react.PropTypes.bool.isRequired,
  fields: _react.PropTypes.object.isRequired,
  dirty: _react.PropTypes.bool.isRequired,
  resetForm: _react.PropTypes.func.isRequired,
  invalid: _react.PropTypes.bool.isRequired,
  pristine: _react.PropTypes.bool.isRequired,
  valid: _react.PropTypes.bool.isRequired,
  closeModalFunc: _react.PropTypes.func,
  handleSubmit: _react.PropTypes.func,
  registerUrl: _react.PropTypes.string,
  hideCloseModalBtn: _react.PropTypes.bool,
  forgetPwdUrl: _react.PropTypes.string,

  isOpened: _react.PropTypes.bool,
  onClose: _react.PropTypes.func,
  onSubmit: _react.PropTypes.func,
  operating: _react.PropTypes.bool,
  errMessage: _react.PropTypes.string
}, _temp)) || _class);
exports.default = CompanyInfoModal;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CompanyInfoModal/CompanyInfoModal.js
 ** module id = 1320
 ** module chunks = 0
 **/